import { css } from "@emotion/core";
import styled from "@emotion/styled";
import React from "react";

import Link from "./Link";

const pages = [
  {
    name: "Features",
    href: "/features",
  },
  {
    name: "Solutions",
    href: "/solutions",
  },
  {
    name: "Resources",
    childs: [
      {
        href: "/apps",
        name: "Apps with Flexa",
      },
      { name: "Currencies", href: "/currencies" },
      { name: "Integrations", href: "/integrations" },
      { name: "Capacity", href: "https://app.flexa.network", external: true },
      { name: "Blog", href: "https://medium.com/flexa", external: true },
      {
        name: "Help Center",
        href: "https://help.flexa.network",
        external: true,
      },
    ],
  },
  {
    name: "Developers",
    href: "https://docs.flexa.co",
    external: true,
  },
];

const NavUL = styled.ul`
  list-style: none;

  padding: 0;
  margin: 0;
`;

const NavMenu = styled(NavUL)`
  width: 100%;
  height: var(--menu-height);

  display: flex;
  justify-content: flex-start;
  align-items: center;

  & > li:first-of-type {
    margin-left: calc(-2 * var(--unit));

    @media only screen and (max-width: 520px) {
      margin-left: 0;
    }
  }
`;

const SubMenuContainer = styled.div`
  z-index: 2;
  display: none;
  position: absolute;
  margin-top: -1rem;
  padding-top: 2rem;

  min-width: 17rem;
`;

const SubMenu = styled(NavUL)`
  border-radius: 1.5rem;
  box-shadow:
    0 4px 12px 0 rgba(72, 93, 255, 0.1),
    0 12px 48px 0 rgba(72, 93, 255, 0.15);
  background-color: #ffffff;

  padding: 1rem;

  left: 0;
`;

const NavLink = styled.span`
  border-radius: 0.75rem;

  /* display: block; */
  padding-left: var(--padding);
  padding-right: var(--padding);
  padding-top: 1rem;
  padding-bottom: 1rem;

  font-weight: 500;
  font-size: calc(1.25 * var(--unit));

  @media only screen and (max-width: 1600px) {
    font-size: 1.5rem;
  }

  @media only screen and (max-width: 520px) {
    font-size: 1.75rem;
    padding-left: 1rem;
    padding-right: 1rem;
  }
`;

const NavItem = styled.li`
  --padding: calc(2 * var(--unit));
  margin: 0;

  position: relative;
  color: #000;

  &:hover > ${NavLink} {
    color: #485dff;
  }

  &:hover ${SubMenuContainer} {
    display: block;
    cursor: pointer;
  }
`;

const SubNavItem = styled(NavItem)`
  --padding: 1rem;

  & ${NavLink} {
    display: block;
    padding-left: var(--padding);
    padding-right: var(--padding);

    font-weight: 500;
    font-size: calc(1.25 * var(--unit));
  }

  & ${NavLink}:hover {
    background-color: rgba(72, 93, 255, 0.05);
  }
`;

const Header = () => (
  <header
    css={css`
      position: relative;
      z-index: 10;
    `}
  >
    <nav
      css={css`
        display: flex;
        justify-content: space-between;
      `}
    >
      <NavMenu css={css``}>
        {pages.map(({ name, href, external, childs }) => {
          const props = href ? { to: href, as: Link, external } : {};
          return (
            <NavItem key={name}>
              <NavLink {...props}>{name}</NavLink>
              {childs ? (
                <SubMenuContainer>
                  <SubMenu>
                    {childs.map(({ name, href, external }) => {
                      const props = href ? { to: href, as: Link, external } : {};
                      return (
                        <SubNavItem key={name}>
                          <NavLink {...props}>{name}</NavLink>
                        </SubNavItem>
                      );
                    })}
                  </SubMenu>
                </SubMenuContainer>
              ) : null}
            </NavItem>
          );
        })}
      </NavMenu>
      <NavMenu
        css={css`
          flex: 0 1 auto;
          justify-content: flex-end;

          @media only screen and (max-width: 520px) {
            display: none;
          }
        `}
      >
        <NavLink
          as={Link}
          css={css`
            color: #7d44ff;
          `}
          to="/solutions"
        >
          Get better payments
        </NavLink>
      </NavMenu>
    </nav>
  </header>
);

export default Header;
